<p-table [value]="menuItem.subscriptions">
	<ng-template pTemplate="header">
		<tr>
			<th>Customer</th>
			<th>Next Bill Date</th>
			<th>Frequency</th>
		</tr>
	</ng-template>
	<ng-template let-rec pTemplate="body">
		<tr>
			<td>{{ app.references.toTitleCase(rec.customerDto.lastName) }} {{ app.references.toTitleCase(rec.customerDto.firstName) }}</td>
			<td>
				{{ app.moment.unix(rec.nextBillDate).format("l") }}
			</td>
			<td>
				<p-dropdown
					#frequencyOption
					[disabled]="true"
					[options]="venueService.subscriptionFrequencyOptions()"
					optionLabel="label"
					optionValue="value"
					name="frequencyOption"
					[(ngModel)]="rec.frequency"
					[style]="{ width: '100%' }"
					appendTo="body"
				></p-dropdown>
			</td>
		</tr>
	</ng-template>
</p-table>
